
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30339',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30339",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.54670",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8046",
  "hubspot-dlb": "static-2.1854",
  "HubStyleTokens": "static-2.11504",
  "I18n": "static-7-hdineen_hubspot-i18n-react-compiler.2",
  "quartz": "static-1.7070",
  "quartz-config": "static-1.848",
  "quartz-core": "static-1.6289",
  "react-dlb": "static-1.79",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.43",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.798",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.54657",
  "feedback-utils": "static-1.54661",
  "forms-embed-utils-lib": "static-1.4495",
  "forms-utils-lib": "static-1.12644",
  "foundations-assets": "static-1.4900",
  "foundations-components": "static-1.7996",
  "foundations-theming": "static-1.4451",
  "hub-http": "static-1.6254",
  "hubspot-url-utils": "static-1.4132",
  "HubStyle": "static-2.11811",
  "icons": "static-2.650",
  "immutable": "static-2.79",
  "quick-fetch": "static-1.3941",
  "raven": "static-3.5925",
  "react": "static-7.186",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1.16705",
  "react-select-plus": "static-1.105",
  "react-utils": "static-2.5369",
  "react-virtualized": "static-2.99",
  "redux": "static-4.16",
  "StyleGuideUI": "static-3.487",
  "tinymce-plugins": "static-1.57587",
  "transmute": "static-2.85",
  "ui-images": "static-2.1160",
  "UIComponents": "static-3.8450",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9637",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3424",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3347",
  "quartz-webpack": "static-1.3294",
  "foundations-theming-specialty": "static-1.2167",
  "property-description-translator": "static-1.3874",
  "HeadJS": "static-2.764",
  "framer-motion": "static-1.72",
  "hs-test-utils-bend-plugin": "static-1.3157",
  "msw": "static-1.39",
  "testing-library": "static-1.152",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.221",
  "moment-timezone": "static-5.83",
  "jasmine": "static-4.4358",
  "jasmine-runner": "static-1.6495",
  "dispatcher": "static-1.137",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.838",
  "hubspotter-http": "static-1.4676",
  "mobile-manifest-mixins": "static-1.538",
  "module-federation": "static-1.23",
  "quartz-auth": "static-1.745",
  "quartz-head": "static-1.735",
  "quartz-i18n": "static-1.745",
  "quartz-routing": "static-1.500",
  "quartz-test": "static-1.745",
  "quartz-tracking": "static-1.449",
  "ui-fonts": "static-1.766",
  "usage-tracker-container": "static-1.7369",
  "usage-tracker-core": "static-1.7229",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.156",
  "conversations-skeleton-state": "static-1.7279",
  "reference-resolvers": "static-1.8203",
  "sanitize-text": "static-1.8174",
  "PatternValidationJS": "static-1.437",
  "ReduxMessenger": "static-2.10397",
  "sanitize": "static-1.4507",
  "outpost": "static-1.4210",
  "rpc-client-utils": "static-1.4684",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4265",
  "floating-ui": "static-1.56",
  "hs-story-utils": "static-1.9455",
  "react-aria": "static-1.66",
  "react-create-root-preference": "static-1.29",
  "tanstack-table": "static-1.55",
  "trellis-assets": "static-1.2037",
  "bend-plugin-foundations-theming": "static-1.2934",
  "foundations-theming-base": "static-1.3436",
  "stylex": "static-1.33",
  "hs-locale-management": "static-1.106",
  "csstype": "static-1.50",
  "web-vitals": "static-1.6",
  "ai-components-ui-library": "static-1.9058",
  "atom": "static-1.5105",
  "codemirror": "static-5.95",
  "content-assistance-lib": "static-1.7798",
  "ContentUtils": "static-1.68472",
  "data-token-picker": "static-1.16460",
  "file-manager-components": "static-1.23717",
  "FileManagerCore": "static-1.39216",
  "FileManagerLib": "static-1.39357",
  "frontend-preferences-client": "static-1.7959",
  "hub-http-contrib": "static-1.3073",
  "interframe": "static-3.4791",
  "layout-dnd-components": "static-1.12503",
  "layout-dnd-utils": "static-1.11478",
  "property-translator": "static-1.5430",
  "react-codemirror": "static-1.10657",
  "react-colorpicker": "static-2.10239",
  "reference-resolvers-lite": "static-1.8127",
  "rich-text-lib": "static-1.19886",
  "tinymce-data": "static-1.40558",
  "tinymce-themes": "static-1.56443",
  "ui-addon-emoji-picker": "static-1.9919",
  "ui-addon-sales-email": "static-1.5242",
  "ui-brand-identity-lib": "static-1.15429",
  "bender-build-tools": "static-1.3227",
  "hub-http-shared-msw-handlers": "static-1.10047",
  "hubspotter-http-shared-msw-handlers": "static-1.10045",
  "usage-tracker-session-replay": "static-1.5065",
  "react-immutable-proptypes": "static-2.8",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.94",
  "chirp-fetch": "static-1.1919",
  "chatspot-core": "static-1.21437",
  "copilot-toolkit": "static-1.11221",
  "customer-data-objects-ui-components": "static-1.13061",
  "data-fetching-client": "static-1.9698",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.4792",
  "ui-addon-video-player": "static-1.8734",
  "ui-coaching-tips": "static-1.28663",
  "usage-tracker": "static-1.7379",
  "cms-field-types": "static-1.4844",
  "content-icons-ui": "static-1.2233",
  "integrations-lib": "static-1.16276",
  "customer-data-objects": "static-1.7705",
  "apollo-dlb": "static-3.86",
  "apollo-link-hub-http": "static-2.4683",
  "apollo-stack-hubspot": "static-3.86",
  "graphql": "static-1.82",
  "immer": "static-1.33",
  "immerable": "static-1.4185",
  "ui-addon-iframeable": "static-1.9092",
  "video-components-external": "static-1.11406",
  "video-data-lib": "static-1.35064",
  "audio-components": "static-1.5961",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29355",
  "FileManagerImages": "static-1.36868",
  "foundations-components-legacy": "static-1.1021",
  "redux-toolkit": "static-1.7",
  "reselect": "static-2.16",
  "salesImages": "static-1.525",
  "ui-universal-auth": "static-1.9015",
  "urlinator": "static-1.4568",
  "video-components": "static-1.13409",
  "video-embed": "static-1.35898",
  "ts-schema": "static-1.4105",
  "ContentData": "static-1.68547",
  "layout-data-lib": "static-1.9803",
  "react-dnd-compat": "static-1.4646",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1573",
  "external-options-client-types": "static-1.4184",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.6917",
  "hs-promise-utils": "static-1.5622",
  "inbound-db-properties-service-client": "static-1.3871",
  "NamespacedHubStyle": "static-2.9083",
  "growth-onboarding-confetti": "static-1.3098",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11180",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5571",
  "magpie-types": "static-1.5031",
  "simple-logging-lib": "static-1.3082",
  "avatar-components": "static-1.2530",
  "customer-data-ui-utilities": "static-1.9857",
  "growth-onboarding-feedback-components": "static-1.6611",
  "flux-actions": "static-1.341",
  "hubspot-apollo-client": "static-1.4910",
  "integrations-error-boundary-lib": "static-1.13691",
  "integrations-tracking-lib": "static-1.5634",
  "laboratory-lib": "static-3.7187",
  "native-integrations-shared-strings": "static-1.7813",
  "redux-observable": "static-1.11",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10203",
  "unified-auth": "static-1.529",
  "navigation-messaging": "static-1.7454",
  "content-media-composition-data-lib": "static-1.12451",
  "content-media-compositions": "static-2.16458",
  "idb-keyval": "static-1.44",
  "media-bridge-lib": "static-1.18979",
  "unified-auth-core-lib": "static-1.811",
  "social-insights-client-types": "static-1.22211",
  "advanced-menus-core": "static-1.15175",
  "advanced-menus-lib": "static-1.12113",
  "ExportDialog": "static-6.10416",
  "ui-memberships-settings-lib": "static-1.34148",
  "conditional-properties-service-client": "static-1.3822",
  "crm-pipelines-api-client-types": "static-1.4164",
  "fdsr-migration-layer": "static-1.36",
  "framework-builder-read-service-client": "static-1.4030",
  "framework-data-schema-quick-fetch": "static-1.6822",
  "inbound-db-meta-service-client": "static-1.3611",
  "multi-currency-client-types": "static-1.3716",
  "persist-promise": "static-1.3730",
  "foundations-components-test-utils": "static-1.5479",
  "reactive-lib": "static-1.754",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.369",
  "universal-page-editor-lib": "static-1.3045",
  "google-sheets-integration-lib": "static-1.346",
  "microsoft-drive-integration-lib": "static-1.471",
  "slack-ui-library": "static-1.10424",
  "js-cookie": "static-1.18",
  "fsm": "static-1.3763",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15174",
  "simple-menus-lib": "static-1.16691",
  "crm-record-cards-service-types": "static-1.3615",
  "location-customization-utils-lib": "static-1.9370",
  "react-flip-move": "static-1.70"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30339",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.54670",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8046",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyleTokens": "/HubStyleTokens/static-2.11504",
  "I18n": "/I18n/static-7-hdineen_hubspot-i18n-react-compiler.2",
  "quartz": "/quartz/static-1.7070",
  "quartz-config": "/quartz-config/static-1.848",
  "quartz-core": "/quartz-core/static-1.6289",
  "react-dlb": "/react-dlb/static-1.79",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.43",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.798",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.54657",
  "feedback-utils": "/feedback-utils/static-1.54661",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4495",
  "forms-utils-lib": "/forms-utils-lib/static-1.12644",
  "foundations-assets": "/foundations-assets/static-1.4900",
  "foundations-components": "/foundations-components/static-1.7996",
  "foundations-theming": "/foundations-theming/static-1.4451",
  "hub-http": "/hub-http/static-1.6254",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyle": "/HubStyle/static-2.11811",
  "icons": "/icons/static-2.650",
  "immutable": "/immutable/static-2.79",
  "quick-fetch": "/quick-fetch/static-1.3941",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.186",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1.16705",
  "react-select-plus": "/react-select-plus/static-1.105",
  "react-utils": "/react-utils/static-2.5369",
  "react-virtualized": "/react-virtualized/static-2.99",
  "redux": "/redux/static-4.16",
  "StyleGuideUI": "/StyleGuideUI/static-3.487",
  "tinymce-plugins": "/tinymce-plugins/static-1.57587",
  "transmute": "/transmute/static-2.85",
  "ui-images": "/ui-images/static-2.1160",
  "UIComponents": "/UIComponents/static-3.8450",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9637",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3424",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3347",
  "quartz-webpack": "/quartz-webpack/static-1.3294",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2167",
  "property-description-translator": "/property-description-translator/static-1.3874",
  "HeadJS": "/HeadJS/static-2.764",
  "framer-motion": "/framer-motion/static-1.72",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3157",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.152",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.221",
  "moment-timezone": "/moment-timezone/static-5.83",
  "jasmine": "/jasmine/static-4.4358",
  "jasmine-runner": "/jasmine-runner/static-1.6495",
  "dispatcher": "/dispatcher/static-1.137",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.838",
  "hubspotter-http": "/hubspotter-http/static-1.4676",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.538",
  "module-federation": "/module-federation/static-1.23",
  "quartz-auth": "/quartz-auth/static-1.745",
  "quartz-head": "/quartz-head/static-1.735",
  "quartz-i18n": "/quartz-i18n/static-1.745",
  "quartz-routing": "/quartz-routing/static-1.500",
  "quartz-test": "/quartz-test/static-1.745",
  "quartz-tracking": "/quartz-tracking/static-1.449",
  "ui-fonts": "/ui-fonts/static-1.766",
  "usage-tracker-container": "/usage-tracker-container/static-1.7369",
  "usage-tracker-core": "/usage-tracker-core/static-1.7229",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.156",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7279",
  "reference-resolvers": "/reference-resolvers/static-1.8203",
  "sanitize-text": "/sanitize-text/static-1.8174",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "ReduxMessenger": "/ReduxMessenger/static-2.10397",
  "sanitize": "/sanitize/static-1.4507",
  "outpost": "/outpost/static-1.4210",
  "rpc-client-utils": "/rpc-client-utils/static-1.4684",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4265",
  "floating-ui": "/floating-ui/static-1.56",
  "hs-story-utils": "/hs-story-utils/static-1.9455",
  "react-aria": "/react-aria/static-1.66",
  "react-create-root-preference": "/react-create-root-preference/static-1.29",
  "tanstack-table": "/tanstack-table/static-1.55",
  "trellis-assets": "/trellis-assets/static-1.2037",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2934",
  "foundations-theming-base": "/foundations-theming-base/static-1.3436",
  "stylex": "/stylex/static-1.33",
  "hs-locale-management": "/hs-locale-management/static-1.106",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.6",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9058",
  "atom": "/atom/static-1.5105",
  "codemirror": "/codemirror/static-5.95",
  "content-assistance-lib": "/content-assistance-lib/static-1.7798",
  "ContentUtils": "/ContentUtils/static-1.68472",
  "data-token-picker": "/data-token-picker/static-1.16460",
  "file-manager-components": "/file-manager-components/static-1.23717",
  "FileManagerCore": "/FileManagerCore/static-1.39216",
  "FileManagerLib": "/FileManagerLib/static-1.39357",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7959",
  "hub-http-contrib": "/hub-http-contrib/static-1.3073",
  "interframe": "/interframe/static-3.4791",
  "layout-dnd-components": "/layout-dnd-components/static-1.12503",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11478",
  "property-translator": "/property-translator/static-1.5430",
  "react-codemirror": "/react-codemirror/static-1.10657",
  "react-colorpicker": "/react-colorpicker/static-2.10239",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8127",
  "rich-text-lib": "/rich-text-lib/static-1.19886",
  "tinymce-data": "/tinymce-data/static-1.40558",
  "tinymce-themes": "/tinymce-themes/static-1.56443",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9919",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5242",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15429",
  "bender-build-tools": "/bender-build-tools/static-1.3227",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10047",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10045",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5065",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.94",
  "chirp-fetch": "/chirp-fetch/static-1.1919",
  "chatspot-core": "/chatspot-core/static-1.21437",
  "copilot-toolkit": "/copilot-toolkit/static-1.11221",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13061",
  "data-fetching-client": "/data-fetching-client/static-1.9698",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.4792",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8734",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28663",
  "usage-tracker": "/usage-tracker/static-1.7379",
  "cms-field-types": "/cms-field-types/static-1.4844",
  "content-icons-ui": "/content-icons-ui/static-1.2233",
  "integrations-lib": "/integrations-lib/static-1.16276",
  "customer-data-objects": "/customer-data-objects/static-1.7705",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4683",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.86",
  "graphql": "/graphql/static-1.82",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4185",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9092",
  "video-components-external": "/video-components-external/static-1.11406",
  "video-data-lib": "/video-data-lib/static-1.35064",
  "audio-components": "/audio-components/static-1.5961",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29355",
  "FileManagerImages": "/FileManagerImages/static-1.36868",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1021",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "reselect": "/reselect/static-2.16",
  "salesImages": "/salesImages/static-1.525",
  "ui-universal-auth": "/ui-universal-auth/static-1.9015",
  "urlinator": "/urlinator/static-1.4568",
  "video-components": "/video-components/static-1.13409",
  "video-embed": "/video-embed/static-1.35898",
  "ts-schema": "/ts-schema/static-1.4105",
  "ContentData": "/ContentData/static-1.68547",
  "layout-data-lib": "/layout-data-lib/static-1.9803",
  "react-dnd-compat": "/react-dnd-compat/static-1.4646",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1573",
  "external-options-client-types": "/external-options-client-types/static-1.4184",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6917",
  "hs-promise-utils": "/hs-promise-utils/static-1.5622",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3871",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9083",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3098",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11180",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5571",
  "magpie-types": "/magpie-types/static-1.5031",
  "simple-logging-lib": "/simple-logging-lib/static-1.3082",
  "avatar-components": "/avatar-components/static-1.2530",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9857",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6611",
  "flux-actions": "/flux-actions/static-1.341",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4910",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13691",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5634",
  "laboratory-lib": "/laboratory-lib/static-3.7187",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7813",
  "redux-observable": "/redux-observable/static-1.11",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10203",
  "unified-auth": "/unified-auth/static-1.529",
  "navigation-messaging": "/navigation-messaging/static-1.7454",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12451",
  "content-media-compositions": "/content-media-compositions/static-2.16458",
  "idb-keyval": "/idb-keyval/static-1.44",
  "media-bridge-lib": "/media-bridge-lib/static-1.18979",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.811",
  "social-insights-client-types": "/social-insights-client-types/static-1.22211",
  "advanced-menus-core": "/advanced-menus-core/static-1.15175",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12113",
  "ExportDialog": "/ExportDialog/static-6.10416",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34148",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3822",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4164",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.36",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4030",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6822",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3611",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3716",
  "persist-promise": "/persist-promise/static-1.3730",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5479",
  "reactive-lib": "/reactive-lib/static-1.754",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.369",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3045",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.346",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.471",
  "slack-ui-library": "/slack-ui-library/static-1.10424",
  "js-cookie": "/js-cookie/static-1.18",
  "fsm": "/fsm/static-1.3763",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15174",
  "simple-menus-lib": "/simple-menus-lib/static-1.16691",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3615",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9370",
  "react-flip-move": "/react-flip-move/static-1.70"
}
};
